<template>
  <div class="index">
    <Menu></Menu>
    <div id="index" style="margin-top: 80px;">
    	<div class="index-first-screen">
			<img src="../assets/img/indexScreen.jpg" alt="" class="pcStyle" />
			<img src="../assets/img/indexScreenMb.jpg" alt="" class="mbStyle"/>
			<div class="index-first-screen-box">
				<div class="index-first-screen-title">企业发展</div>
				<div class="index-first-screen-text">创新、协调、绿色、开放、共享</div>
			</div>
		</div>
		<div class="index-second-screen">
			<div class="index-second-screen-box">
				<div class="third-screen-little-title">Company Profile</div>
				<div class="third-screen-title">企业简介</div>
				<div class="index-second-screen-content">
					<div class="index-second-screen-left">
						<div>
							中亚环保科技集团是黑龙江省再生资源行业龙头企业，全国再生资源行业骨干企业。集团长期致力于固体废物资源化利用和生态环境资源可持续发展，以“建设资源节约型，环境友好型社会”为指导，以“挖掘城市矿产，建设美好家园”为使命，打造区域循环经济与再生资源回收体系的“全产业链”。为推动黑龙江省循环经济再生资源产业实现工业化进程和高质量发展，推进生态文明建设、助力实现碳达标碳中和目标做出积极贡献。
						</div>
						<div>
							集团下属31家子公司，承担建设哈尔滨循环经济产业园区－国家“城市矿产”示范基地、废旧物资循环利用体系。
						</div>
						<div>
							中亚环保科技集团将继续致力以创新、协调、绿色、开放、共享的新发展理念为引领，通过推动形成绿色发展方式和生活方式，持续推进固体废物源头减量和资源化利用，将固体废物环境影响降至最低，努力建设无废城市，为建设美丽中国、美丽黑龙江做出贡献。
						</div>
					</div>
					<div>
						<img src="../assets/img/qiyeright.jpg" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div class="index-third-screen">
			<video src="../assets/img/vedio.mp4" style="width: 100%;height: auto;" 
			     :autoplay='autoplay' :loop='loop'>
			</video>
			<div class="index-third-screen-box">
				<div class="index-third-screen-flex">
					<div class="index-third-screen-content">
						<div class="index-third-screen-div">
							<div class="index-third-screen-number">31</div>
							<div class="index-third-screen-text">集团下属31家子公司</div>
						</div>
					</div>
					<div class="index-third-screen-content">
						<div class="index-third-screen-div">
							<div class="index-third-screen-number">100<span class="index-third-screen-text" style="margin-left: 5px;">强</span></div>
							<div class="index-third-screen-text">中国再生资源行业百强企业</div>
						</div>
					</div>
					<div class="index-third-screen-content">
						<div class="index-third-screen-div">
							<div class="index-third-screen-number">50<span class="index-third-screen-text" style="margin-left: 5px;">强</span></div>
							<div class="index-third-screen-text">哈尔滨市民营企业50强</div>
						</div>
					</div>
					<div class="index-third-screen-content">
						<div class="index-third-screen-div">
							<div class="index-third-screen-number">AAA<span class="index-third-screen-text" style="margin-left: 5px;">强</span></div>
							<div class="index-third-screen-text">中国再生资源行业“AAA级信用企业”</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="index-fifth-screen">
			<div class="companyProfile-name">
				<div class="companyProfile-eglish" style="color:#fff">
					Development history
				</div>
				<div class="companyProfile-chinese" style="color:#fff">
					发展历程
				</div>
			</div>
			<div class="development-course pcStyle">
				<div class="development-course-left">
				 	<div class="development-course-one"></div>
					<div class="development-course-two"></div>
					<div class="development-course-three">2014</div>
					<div class="development-course-four">2014</div>
					<div class="development-course-text">
						园区被国家发改委、财政部批复为国家“城市矿产”示范基地，是国家十二五规划期间循环经济重大项目。
					</div>
				</div>
				<div class="development-course-right">
				 	 <div class="development-course-five"></div>
				 	 <div class="development-course-six"></div>
				 	 <div class="development-course-seven">2015</div>
				 	 <div class="development-course-eight">2015</div>
					 <div class="development-course-content">获得哈尔滨市工信委颁发“哈尔滨市优秀信用中小工业企业”称号。</div>
				</div>
				<div class="development-course-left">
				 	<div class="development-course-one"></div>
					<div class="development-course-two"></div>
					<div class="development-course-three">2016</div>
					<div class="development-course-four">2016</div>
					<div class="development-course-text">
						获得市文明办、诚信办等颁发的“诚信示范单位(企业)”称号；
						
						连续3年被哈尔滨市委市政府授予“哈尔滨发展经济贡献奖”；
						
						被纳入黑龙江省及哈尔滨市国民经济和社会发展第十三个五年规划，列入哈尔滨市十三五规划循环型产业体系重大工程项目。
			
					</div>
				</div>
				<div class="development-course-right">
				 	 <div class="development-course-five"></div>
				 	 <div class="development-course-six"></div>
				 	 <div class="development-course-seven">2018</div>
				 	 <div class="development-course-eight">2018</div>
					 <div class="development-course-content">连续6年被评为“中国再生资源行业百强企业”、中国再生资源行业“AAA级信用企业”</div>
				</div> 
				<div class="development-course-left">
				 	<div class="development-course-one"></div>
					<div class="development-course-two"></div>
					<div class="development-course-three">2020</div>
					<div class="development-course-four">2020</div>
					<div class="development-course-text">
						被纳入黑龙江省及哈尔滨市国民经济和社会发展第十四个五年规划和二〇三五年远景目标纲要。
					</div>
				</div>
				<div class="development-course-right">
				 	 <div class="development-course-five"></div>
				 	 <div class="development-course-six"></div>
				 	 <div class="development-course-seven">2023</div>
				 	 <div class="development-course-eight">2023</div>
					 <div class="development-course-content">入选哈尔滨市民营企业50强、民营制造业企业50强。</div>
				</div>
			</div>
			<div class="swiper-container-mb mbStyle">
			        <div class="swiper-wrapper">
			            <div class="swiper-slide" data-hash="slide1">
							<div class="development-course-left">
							 	<div class="development-course-one"></div>
								<div class="development-course-two"></div>
								<div class="development-course-three">2014</div>
								<div class="development-course-four">2014</div>
								<div class="development-course-text">
									园区被国家发改委、财政部批复为国家“城市矿产”示范基地，是国家十二五规划期间循环经济重大项目。
								</div>
							</div>
						</div>
						<div class="swiper-slide" data-hash="slide2">
							<div class="development-course-right">
							 	 <div class="development-course-five"></div>
							 	 <div class="development-course-six"></div>
							 	 <div class="development-course-seven">2015</div>
							 	 <div class="development-course-eight">2015</div>
								 <div class="development-course-content">获得哈尔滨市工信委颁发“哈尔滨市优秀信用中小工业企业”称号。</div>
							</div>
						</div>
						<div class="swiper-slide" data-hash="slide3">
							<div class="development-course-left">
							 	<div class="development-course-one"></div>
								<div class="development-course-two"></div>
								<div class="development-course-three">2016</div>
								<div class="development-course-four">2016</div>
								<div class="development-course-text">
									获得市文明办、诚信办等颁发的“诚信示范单位(企业)”称号；
									
									连续3年被哈尔滨市委市政府授予“哈尔滨发展经济贡献奖”；
									
									被纳入黑龙江省及哈尔滨市国民经济和社会发展第十三个五年规划，列入哈尔滨市十三五规划循环型产业体系重大工程项目。
							
								</div>
							</div>
						</div>
						<div class="swiper-slide" data-hash="slide4">
							<div class="development-course-right">
							 	 <div class="development-course-five"></div>
							 	 <div class="development-course-six"></div>
							 	 <div class="development-course-seven">2018</div>
							 	 <div class="development-course-eight">2018</div>
								 <div class="development-course-content">连续6年被评为“中国再生资源行业百强企业”、中国再生资源行业“AAA级信用企业”</div>
							</div> 
						</div>
						<div class="swiper-slide" data-hash="slide5">
							<div class="development-course-left">
							 	<div class="development-course-one"></div>
								<div class="development-course-two"></div>
								<div class="development-course-three">2020</div>
								<div class="development-course-four">2020</div>
								<div class="development-course-text">
									被纳入黑龙江省及哈尔滨市国民经济和社会发展第十四个五年规划和二〇三五年远景目标纲要。
								</div>
							</div>
						</div>
						<div class="swiper-slide" data-hash="slide6">
							<div class="development-course-right">
							 	 <div class="development-course-five"></div>
							 	 <div class="development-course-six"></div>
							 	 <div class="development-course-seven">2023</div>
							 	 <div class="development-course-eight">2023</div>
								 <div class="development-course-content">入选哈尔滨市民营企业50强、民营制造业企业50强。</div>
							</div>
						</div>
			        </div>
			        <!-- Add Pagination -->
			        <div class="swiper-pagination"></div>
			        <!-- Add Arrows -->
			        <div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
		</div>
		<div class="index-sixth-screen">
			<div class="index-sixth-screen-swiper">
				<div class="third-screen-little-title" style="text-align: left;">Leadership care</div>
				<div class="third-screen-title" style="text-align: left;">领导关怀</div>
				<div class="swiper mySwiperGuanhuai pcStyle">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<img src="../assets/img/pic1.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委书记、省长王文涛	  
								</div>
								<div>
									到社区参加生活垃圾分类志愿者服务活动									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic2.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委书记、省人大常委会主任张庆伟
								</div>
								<div>
									参加节能宣传周生活垃圾分类活动 									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic3.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委常委、副省长王永康
								</div>
								<div>
									到社区参加生活垃圾分类志愿者服务活动 									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic4.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省政府副省长聂云凌
								</div>
								<div>
									调研松北区生活垃圾分类示范社区 									  
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-button-next"></div>
					   <div class="swiper-button-prev"></div>
					<div class="swiper-pagination"></div>
				</div>
				<div class="swiper mySwiperGuanhuai-mb mbStyle">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<img src="../assets/img/pic1.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委书记、省长王文涛	  
								</div>
								<div>
									到社区参加生活垃圾分类志愿者服务活动									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic2.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委书记、省人大常委会主任张庆伟
								</div>
								<div>
									参加节能宣传周生活垃圾分类活动 									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic3.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省委常委、副省长王永康
								</div>
								<div>
									到社区参加生活垃圾分类志愿者服务活动 									  
								</div>
							</div>
						</div>
						<div class="swiper-slide">
							<img src="../assets/img/pic4.png" alt="" />
							<div class="guanhuai-text">
								<div>
									黑龙江省政府副省长聂云凌
								</div>
								<div>
									调研松北区生活垃圾分类示范社区 									  
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-button-next"></div>
					   <div class="swiper-button-prev"></div>
				</div>
			</div>
			<div class="companyProfile-box">
				<div class="companyProfile-content">
					<div>
						<div class="companyProfile-name">31</div>
						<div class="companyProfile-product">集团下属31家子公司</div>
					</div>
					<div>
						<div class="companyProfile-name">100<span id="">强</span></div>
						<div class="companyProfile-product">中国再生资源行业百强企业</div>
					</div>
					<div>
						<div class="companyProfile-name">50<span id="">强</span></div>
						<div class="companyProfile-product">哈尔滨市民营企业50强</div>
					</div>
					<div>
						<div class="companyProfile-name">AAA<span id="">强</span></div>
						<div class="companyProfile-product">中国再生资源行业“AAA级信用企业”</div>
					</div>
				</div>
			</div>
		</div>
		<div class="index-senveth-screen">
			<div class="index-senveth-screen-box">
				<div class="third-screen-little-title" style="text-align: left;">Company impression</div>
				<div class="third-screen-title" style="text-align: left;">中亚印象</div>
				<div class="yinxiang">
					<div class="yinxiang-box pcStyle">
						<div class="yinxiang-box-left">
							<div>
								<img src="../assets/img/img1.jpg" alt="" />
							</div>
							<div class="yinxiang-box-left-box">
								<div>
									<img src="../assets/img/img2.jpg" alt=""/>
								</div>
								<div>
									<img src="../assets/img/img3.jpg" alt="" style="height: 100%;"/>
								</div>
							</div>
						</div>
						<div class="yinxiang-box-right">
							<img src="../assets/img/img4.jpg" alt=""  style="height: 100%;"/>
						</div>
					</div>
					<div class="mbStyle yinxiang-box-mb">
						<img src="../assets/img/yinxiangmb.png" alt=""  style="height: 100%;"/>
					</div>
				</div>
			</div>
		</div>
    </div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'index',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		autoplay:true,
		loop:true
      };
    },
	mounted(){
		new Swiper(".mySwiperGuanhuai", {
		      slidesPerView: 3,
		      spaceBetween: 30,
		      pagination: {
		        el: ".swiper-pagination",
		        clickable: true,
		      },
			  navigation: {
			  	nextEl: ".swiper-button-next",
			  	prevEl: ".swiper-button-prev",
			    },
		});
		new Swiper(".mySwiperGuanhuai-mb", {
		      slidesPerView: 1,
		      spaceBetween: 30,
		      pagination: {
		        el: ".swiper-pagination",
		        clickable: true,
		      },
			  navigation: {
			  	nextEl: ".swiper-button-next",
			  	prevEl: ".swiper-button-prev",
			    },
		});
		new Swiper('.swiper-container-mb', {
			pagination: '.swiper-pagination',
			paginationClickable: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			  },
			spaceBetween: 30,
			hashnav: true,
			hashnavWatchState: true,
			slidesPerView:1.5,
		});
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/index.scss';
html,body {
	position: relative;
	height: 100%;
}
body {
	margin: 0;
	padding: 0;
}
.swiper {
	width: 100%;
	height: 100%;
}
.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;
}
.swiper-slide img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.banluai .swiper-container {
      width: 100%;
      height: 100%;
    }
.banluai .swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #000;
	position: relative;
	/* Center slide text vertically */
	display: -webkit-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
	transition: 300ms;
	transform: scale(0.8);
}
.banluai .swiper-slide-active,.swiper-slide-duplicate-active{
	transform: scale(1);
}	
</style>


// WEBPACK FOOTER //
// src/components/Index.vue